import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=23a360c7&"
import script from "./transition.vue?vue&type=script&lang=js&"
export * from "./transition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports